import script from "./HoldingDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./HoldingDetail.vue?vue&type=script&setup=true&lang=js"

import "./HoldingDetail.vue?vue&type=style&index=0&id=3d1146be&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d1146be"]])

export default __exports__